<script setup lang="ts">
import { gsap } from "gsap";
import { SplitText } from "gsap/SplitText";

const config = useRuntimeConfig();

const sliderData = useState<SliderData>("slider-data");

const backgroundImage = computed(() => {
  return `url(${config.public.metApiBaseUrl}${sliderData.value?.slides[0]?.image.url})`;
});

onMounted(async () => {
  if (import.meta.client) {
    gsap.registerPlugin(SplitText);

    await nextTick();

    // Nascondi tutti gli elementi inizialmente
    gsap.set(".cd-words-wrapper b", { opacity: 0 });

    // Crea una timeline che si ripete all'infinito
    const tl = gsap.timeline({ repeat: -1 });

    const words = document.querySelectorAll(".cd-words-wrapper b");

    words.forEach((word, index) => {
      // Crea SplitText per ogni parola
      const splitText = new SplitText(word, { type: "chars" });
      const chars = splitText.chars;

      // Imposta stato iniziale dei caratteri
      gsap.set(chars, { y: 100, opacity: 0 });
      gsap.set(word, { opacity: 1 });

      if (index === 0) {
        // Anima l'entrata del primo elemento immediatamente
        tl.to(
          chars,
          {
            y: 0,
            opacity: 1,
            duration: 0.3,
            stagger: 0.05,
          },
          0
        );

        // Dopo 2 secondi, fai uscire i caratteri
        tl.to(
          chars,
          {
            y: -100,
            opacity: 0,
            duration: 0.3,
            stagger: 0.02,
          },
          "+=2"
        );
      } else {
        // Fai entrare i caratteri dell'elemento successivo
        tl.to(
          chars,
          {
            y: 0,
            opacity: 1,
            duration: 0.3,
            stagger: 0.05,
          },
          "-=0.3"
        );

        // Se non è l'ultimo elemento, fallo uscire dopo 2 secondi
        if (index < words.length - 1) {
          tl.to(
            chars,
            {
              y: -100,
              opacity: 0,
              duration: 0.3,
              stagger: 0.02,
            },
            "+=2"
          );
        } else {
          // Per l'ultimo elemento, aspetta prima di ripartire
          tl.to(
            chars,
            {
              y: -100,
              opacity: 0,
              duration: 0.3,
              stagger: 0.02,
            },
            "+=2"
          );
        }
      }
    });
  }
});
</script>

<template>
  <div
    class="slider-area"
    :style="{
      backgroundImage: backgroundImage,
    }"
  >
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="banner-static-content met-banner" >
            <h1 class="cd-headline letters rotate-3 is-full-width gap-20 met-h1" style="color: white; display: flex">
              <span style="padding-right: 2rem">I am</span>
              <span class="cd-words-wrapper">
                <b>Met</b>
                <b v-for="word in sliderData?.slides[0]!.words" :key="word.id">{{ word.text }}</b>
              </span>
            </h1>
            <p style="color: var(--paragraph-color)">{{ sliderData?.slides[0]!.description }}</p>
            <NuxtLink to="/contact" class="button-boxed" style="margin-top: 1.5rem">Contact Me <i class="ti-arrow-right"></i></NuxtLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.slider-area {
  background-repeat: no-repeat;
  background-position: top center;
  background-color: #f5f5f5;
  background-size: cover;
}
.cd-words-wrapper {
  color: var(--primary-color);
}

.met-banner {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.met-h1 {
  margin-right: 225px;
}
/* .slider-style-1{
    background-image: url('https://picsum.photos/1920/1080?grayscale');
} */
</style>
